import type { Icon } from 'phosphor-react-native';
import {
  Drop,
  Eye,
  Leaf,
  PaintBrush,
  Scissors,
  Sparkle,
  Star,
} from 'phosphor-react-native';
import { withUnistyles } from 'react-native-unistyles';

const themed = (PhosphorIcon: Icon) =>
  withUnistyles(PhosphorIcon, (theme) => ({ color: theme.iconPrimary }));

const FallbackIcon = themed(Star);

const ICONS_BY_LIBRARY_KEY: Record<string, typeof FallbackIcon> = {
  hair: themed(Scissors),
  skin: themed(Sparkle),
  brows_lashes: themed(Eye),
  makeup: themed(PaintBrush),
  hair_removal: themed(Drop),
  body_wellness: themed(Leaf),
};

export const getCategoryIcon = (libraryKey?: string | null) =>
  libraryKey &&
  Object.prototype.hasOwnProperty.call(ICONS_BY_LIBRARY_KEY, libraryKey)
    ? ICONS_BY_LIBRARY_KEY[libraryKey]
    : FallbackIcon;
